import { AffindaCredential, AffindaAPI } from "@affinda/affinda";
const credential = new AffindaCredential(KEY_AFFINDA);
const client = new AffindaAPI(credential);
var aboutMe = '';
var currentLevel = '';
var yearExperience = '';
const UPLOAD_CV = {
    cv: null,
    
    init() {
        this.uploadCV();
        this.deleteFileUpload();
        this.submitCV();
    },

    uploadCV() {
        $('#upload-cv').change(function (event) {
            var ext = $(this).val().split('.').pop().toLowerCase();
            if ($.inArray(ext, ['pdf', 'doc', 'docx']) == -1){
                Toast.fire({
                    icon: 'error',
                    title: "File format must be: pdf, .doc or .docx"
                });
                return 1;
            }

            UPLOAD_CV.cv = event.target.files[0];
            if (event.target.files[0].size > 2500000){
                Toast.fire({
                    icon: 'error',
                    title: "File's size max is 25MB"
                });
                return 1;
            }

            $('.div-not-upload').addClass('d-none');
            $('.div-uploading').removeClass('d-none');
            $('.fake-progress-bar').css('width', '100%');

            var filename = $(this).val().replace(/.*(\/|\\)/, '');
            if (filename) {
                $('.file-cv-name b').text(filename);
            }

            setTimeout(function (){
                $('.div-uploading').addClass('d-none');
                $('.div-uploaded').removeClass('d-none');
                $('.btn-submit-cv').removeClass('d-none');
                $('.btn-upload-cv').addClass('d-none');
            }, 500);
        });
    },

    deleteFileUpload() {
        $('.delete-cv-upload').click(function () {
            $('.div-not-upload').removeClass('d-none');
            $('.div-uploading').addClass('d-none');
            $('.div-uploaded').addClass('d-none');
            $('.fake-progress-bar').css('width', '0%');
            $('#upload-cv').val('')
            $('.file-cv-name b').text('');
            $('.btn-upload-cv').removeClass('d-none');
        });
    },

    submitCV() {
        $('.btn-submit-cv').click(function () {
            // open comment
            if (!UPLOAD_CV.cv) {
                Toast.fire({
                    icon: 'error',
                    title: "Please choose a file to upload"
                });

                return 1;
            }
            var formData = new FormData();
            var token = $("meta[name='csrf-token']").attr("content");
            formData.append('cv', UPLOAD_CV.cv);
            formData.append('_token', token);
            $('.js-loading-mask').removeClass('is-remove');

            $.ajax({
                type: 'POST',
                url: $(this).data('route'),
                data: formData,
                contentType: false,
                processData: false,
                error: function(response) {
                }
            });
            UPLOAD_CV.parsingCV();
        })
    },

    parsingCV() {
        if (UPLOAD_CV.cv) {
            client.createResume({file: UPLOAD_CV.cv})
            .then((result) => {
                UPLOAD_CV.saveInfoBio(result.data);
                Toast.fire({
                    icon: 'success',
                    title: msg_upload_cv_success
                });
                $('.js-loading-mask').addClass('is-remove');
                window.onbeforeunload = null;
                window.location.href = ROUTE_CREATE_CV
            })
            .catch((error) => {
                $('.js-loading-mask').addClass('is-remove');
                window.location.href = ROUTE_CREATE_CV
            })
        }
    },

    saveInfoBio(data) {
        var latest = null;
        try {
            UPLOAD_CV.saveBioOverview(data);
        } catch(err) {
            console.log(err);
        }
        try {
            latest = UPLOAD_CV.saveBioCurrentJob(data);
        } catch(err) {
            console.log(err);
        }
        try {
            UPLOAD_CV.saveBioExpJob(data, latest);
        } catch(err) {
            console.log(err);
        }
        try {
            UPLOAD_CV.saveBioEducation(data);
        } catch(err) {
            console.log(err);
        }
        try {
            UPLOAD_CV.saveBioLanguage(data);
        } catch(err) {
            console.log(err);
        }
        // try {
        //     UPLOAD_CV.saveLocation(data);
        // } catch(err) {
        //     console.log(err);
        // }
    },

    saveBioCurrentJob(data) {
        var currentDate = new Date();
        var exp = null;
        var filteredObjects = data.workExperience.filter(function(obj) {
            if(!obj.dates) return false;
            if (obj.dates.isCurrent || !obj.dates.endDate) {
                exp = obj;
                return true;
            } else {
                var endDate = new Date(obj.dates.endDate);
                if (!exp || Math.abs(endDate - currentDate) < Math.abs(new Date(exp.dates.endDate) - currentDate)) {
                    exp = obj;
                }
                return false;
            }
        });

        if(exp){
            var dataSend = {
                "_token": $("meta[name='csrf-token']").attr("content"),
                company_name: exp.organization,
                current_role: exp.jobTitle,
                current_month: exp.dates ? new Date(exp.dates.startDate).getMonth() + 1 : 1,
                current_year: exp.dates ? new Date(exp.dates.startDate).getFullYear() : 1990,
                current_end_month: exp.dates ? new Date(exp.dates.endDate).getMonth() + 1 : 1,
                current_end_year: exp.dates ? new Date(exp.dates.endDate).getFullYear() : 1990,
                current_salary: null,
                description: null,
                is_work: exp.dates && exp.dates.isCurrent ? 1 : 0,
            }
            $.ajax({
                url: SAVE_BIO_CURRENT_JOB,
                type: 'POST',
                data: dataSend,
                success: function(response) {
                    $('#curent-job-list').html(response.view);
                    $('.btn-add-current-job').css('display', 'none')
                    $('.job-detail-section').css('display', 'none');
                }
            });
    
        }
        return exp;
    },

    saveBioExpJob(data, latest = null) {
        data.workExperience.forEach(function (exp) {
            if (exp!= latest && exp.dates && !exp.dates.isCurrent) {
                let startDate = exp.dates ? exp.dates.startDate : null;
                let endDate = exp.dates ? exp.dates.endDate : null;
                let rawText = exp.dates ? exp.dates.rawText : null;
                if((!startDate || !endDate) && rawText){
                    var regex = /\b(\d{1,2}\/\d{1,2}\/\d{4})\b|\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}\b|\b(\d{1,2}\/\d{4})\b/g;
                    var matches = rawText.match(regex);
                    if(matches.length > 1){
                        startDate = matches[0];
                        endDate = matches[matches.length - 1];
                    }
                }
                var dataSend = {
                    "_token": $("meta[name='csrf-token']").attr("content"),
                    company_name: exp.organization,
                    ex_role: exp.jobTitle,
                    ex_month: startDate ? new Date(startDate).getMonth() + 1 : 1,
                    ex_year: startDate ? new Date(startDate).getFullYear() : 1990,
                    ex_end_month: endDate ? new Date(endDate).getMonth() + 1 : 1,
                    ex_end_year: endDate ? new Date(endDate).getFullYear() : 1990,
                    current_salary: null,
                    description: null,
                }

                $.ajax({
                    url: SAVE_BIO_EXP_JOB,
                    type: 'POST',
                    data: dataSend,
                    success: function(response) {
                        $('#err_type_1').html('');
                        $('#experience-job-list').html(response.view);
                        $('.btn-add-current-experience').css('display', 'inline-block');
                        $('#experience-detail-section').css('display', 'none');
                        $('#ex_company').val('');
                        $('#ex_role').val('');
                        $('#ex_description').val('');
                    }
                });
            }
        })
    },

    saveBioEducation(data) {
        data.education.forEach(function (edu) {
            var dataSend = {
                "_token": $("meta[name='csrf-token']").attr("content"),
                university: edu.organization,
                major: 1,
                qualification: edu.accreditation.inputStr,
                start_month: edu.dates ? parseInt(new Date(edu.dates.startDate).getMonth()) + 1 : 0,
                start_year: edu.dates ? new Date(edu.dates.startDate).getFullYear() : 0,
                end_month: edu.dates ? new Date(edu.dates.completionDate).getMonth() + 1 : 0,
                end_year: edu.dates ? new Date(edu.dates.completionDate).getFullYear() : 0,
                description: null
            }

            $.ajax({
                url: SAVE_BIO_EDUCATION,
                type: 'POST',
                data: dataSend,
                success: function(response) {
                    $('#err_type_3').html('');
                    $('#education-list').html(response.view);
                    $('.btn-add-education').css('display', 'inline-block');
                    $('#education-detail-section').css('display', 'none');
                    $('#university').val('');
                    $('#major').val('');
                    $('#edu_description').val('');
                }
            });
        })
    },

    saveBioLanguage(data) {
        let languages = data.languages;
        if(languages.length <= 0){
            return;
        }
        var dataSend = {
            "_token": $("meta[name='csrf-token']").attr("content"),
            languages: languages,
            level: 'Native',
        }

        $.ajax({
            url: SAVE_LANGUAGE_CV,
            type: 'POST',
            data: dataSend,
            success: function(response) {
                $('#err_type_4').html('');
                $('.btn-add-language').css('display', 'inline-block');
                $('.language-detail-section').css('display', 'none');
            }
        });
    },

    saveLocation(data) {
        if (data.location && data.location.rawInput) {
            var dataSend = {
                "_token": $("meta[name='csrf-token']").attr("content"),
                location: data.location.rawInput,
            }

            $.ajax({
                url: SAVE_LOCATION,
                type: 'POST',
                data: dataSend,
                success: function(response) {
                    $('.btn-add-location').css('display', 'none');
                    $('#err_type_5').html('');
                    $('#location-list').html(response.view);
                    $('.location-detail-section').css('display', 'none');
                    $('#bio_location').val('');
                }
            });
        }
    },

    saveBioOverview(data){
        let aboutMe = '';
        let rawText = data.rawText;
        let expSalary = '';
        let currency = 'HKD';
        let noticePeriod = '';
        var expectSalaryKey = 'EXPECTED SALARY';
        var noticeKey = 'PERIOD';
        if(rawText.length > 0){
            let endIndex = rawText.indexOf("NATIVE LANGUAGE");
            let extracted = rawText.substring(0, endIndex).trim();
            aboutMe = extracted.replace('ABOUT ME', '').trim();

            let startIndexSalary = rawText.indexOf(expectSalaryKey);
            let salaryStr = rawText.substring(startIndexSalary + expectSalaryKey.length).trim();
            let expSalaryArr = salaryStr.match(/\d+(,\d+)?/);
            if(expSalaryArr){
                expSalary = expSalaryArr[0];
                let salaryIndex = rawText.indexOf(expSalary);
                let currency = rawText.substring(salaryIndex - 4, salaryIndex).trim();
            }      
        }
        let indexOfNotice = rawText.indexOf(noticeKey);
        if(indexOfNotice !== -1){
            let noticeStr = rawText.substring(indexOfNotice).trim();
            let endNotice  = noticeStr.indexOf(" ", noticeStr.indexOf(" ", noticeStr.indexOf(" ") + 1) + 1); //third space
            noticePeriod = noticeStr.substring(noticeKey.length, endNotice).trim();
        }
        if(!aboutMe){
            aboutMe = data.summary;
        }
        let sections = data.sections;
        var careerLevelSection = $.grep(sections, function(obj) {
            return obj.text.indexOf('CURRENT CAREER LEVEL') !== -1 || obj.text.indexOf(' LEVEL OF EXPERIENCE') !== -1 ;
        });
        let currentLevel = 0;
        if(careerLevelSection.length > 0){
            let careerLevelObj = careerLevelSection[0];
            let currentLevelParse = careerLevelObj.text.replace('CURRENT CAREER LEVEL', '').trim();
            currentLevelParse = currentLevelParse.replace('LEVEL OF EXPERIENCE', '').trim();
            switch(true){
                case currentLevelParse.includes('Fresh'):
                    currentLevel = 0;
                    break;
                case currentLevelParse.includes('Supervisor'):
                    currentLevel = 1;
                    break;
                case currentLevelParse.includes('Mid'):
                    currentLevel = 2;
                    break;
                case currentLevelParse.includes('Senior Management'):
                    currentLevel = 3;
                    break;
                default:
                    currentLevel = 0;
            }
        }
        
        let experienceSection = $.grep(sections, function(obj) {
            return obj.text.indexOf('YEARS OF EXPERIENCE') !== -1;
        });
        let yearExperience = '';
        let numberOfYear = 0;
        if(experienceSection.length > 0){
            let experienceParse = experienceSection[0].text;
            var yearExpKey = 'YEARS OF EXPERIENCE';
            var yearKey = 'Year';
            let startYearIndex = experienceParse.indexOf(yearExpKey);
            let endYearIndex = experienceParse.indexOf(yearKey);
            numberOfYear = experienceParse.substring(startYearIndex + yearExpKey.length, endYearIndex).trim();
            numberOfYear = Number(numberOfYear);
            if(numberOfYear){
                let currentDate = new Date();
                let currentYear = currentDate.getFullYear();
                yearExperience = currentYear - numberOfYear;
            }
        }
        $.ajax({
            url: SAVE_BIO_OVERVIEW,
            type: 'POST',
            data:{
                currentLevel: currentLevel,
                yearExperience: yearExperience,
                numberOfYear: numberOfYear,
                aboutMe: aboutMe,
                currency: currency,
                expSalary: expSalary,
                noticePeriod: noticePeriod,
            },
        });
        return true;
    },
}

$(function () {
    UPLOAD_CV.init(); 
})